<div class="page-container">
  <div class="page-header">
    <div class="header-icon">
      <mat-icon>settings</mat-icon>
    </div>
    <div class="header-text">
      <h1>Masters</h1>
      <p>Manage your master data and configurations</p>
    </div>
  </div>

  <div class="landing-grid">
    <a routerLink="/doctor" class="landing-card">
      <div class="card-icon"><mat-icon>person</mat-icon></div>
      <div class="card-text">
        <h3>Doctors</h3>
        <p>Manage doctor profiles and contacts</p>
      </div>
    </a>
    <a routerLink="/product" class="landing-card">
      <div class="card-icon"><mat-icon>inventory_2</mat-icon></div>
      <div class="card-text">
        <h3>Products</h3>
        <p>Product catalog and specifications</p>
      </div>
    </a>
    <a routerLink="/category" class="landing-card">
      <div class="card-icon"><mat-icon>category</mat-icon></div>
      <div class="card-text">
        <h3>Product Category</h3>
        <p>Organize products into categories</p>
      </div>
    </a>
    <a routerLink="/jobchecklist" class="landing-card">
      <div class="card-icon"><mat-icon>checklist</mat-icon></div>
      <div class="card-text">
        <h3>Job Checklist</h3>
        <p>Job order checklists and templates</p>
      </div>
    </a>
    <a routerLink="/shipment" class="landing-card">
      <div class="card-icon"><mat-icon>local_shipping</mat-icon></div>
      <div class="card-text">
        <h3>Shipment</h3>
        <p>Shipment methods and tracking</p>
      </div>
    </a>
    <a routerLink="/hsn" class="landing-card">
      <div class="card-icon"><mat-icon>tag</mat-icon></div>
      <div class="card-text">
        <h3>HSN</h3>
        <p>HSN/SAC codes for taxation</p>
      </div>
    </a>
    <a routerLink="/area" class="landing-card">
      <div class="card-icon"><mat-icon>location_city</mat-icon></div>
      <div class="card-text">
        <h3>City</h3>
        <p>City/area master data</p>
      </div>
    </a>
    <a routerLink="/state" class="landing-card">
      <div class="card-icon"><mat-icon>map</mat-icon></div>
      <div class="card-text">
        <h3>State</h3>
        <p>State/region master data</p>
      </div>
    </a>
    <a routerLink="/remark" class="landing-card">
      <div class="card-icon"><mat-icon>comment</mat-icon></div>
      <div class="card-text">
        <h3>Remark</h3>
        <p>Predefined remarks and notes</p>
      </div>
    </a>
    <a routerLink="/employee" class="landing-card">
      <div class="card-icon"><mat-icon>badge</mat-icon></div>
      <div class="card-text">
        <h3>Employee</h3>
        <p>Employee profiles and roles</p>
      </div>
    </a>
    <a routerLink="/department" class="landing-card">
      <div class="card-icon"><mat-icon>business</mat-icon></div>
      <div class="card-text">
        <h3>Department</h3>
        <p>Departmental structure</p>
      </div>
    </a>
    <a routerLink="/process" class="landing-card">
      <div class="card-icon"><mat-icon>engineering</mat-icon></div>
      <div class="card-text">
        <h3>Process</h3>
        <p>Manufacturing processes</p>
      </div>
    </a>
    <a routerLink="/pricelist" class="landing-card">
      <div class="card-icon"><mat-icon>request_quote</mat-icon></div>
      <div class="card-text">
        <h3>Product Price List</h3>
        <p>Pricing and rate cards</p>
      </div>
    </a>
    <a routerLink="/account" class="landing-card">
      <div class="card-icon"><mat-icon>account_balance</mat-icon></div>
      <div class="card-text">
        <h3>Account</h3>
        <p>Chart of accounts</p>
      </div>
    </a>
  </div>
</div>
